import { SERVICE_WORKER_UPDATE_CHECK_INTERVAL } from "@/constants";
import { useCallback } from "react";
import { useRegisterSW } from "virtual:pwa-register/react";

export const useUpdatePrompt = () => {
  const {
    needRefresh: [needRefresh],
    updateServiceWorker,
  } = useRegisterSW({
    onRegistered(registration) {
      if (!registration) {
        return;
      }
      setInterval(
        () => registration.update(),
        SERVICE_WORKER_UPDATE_CHECK_INTERVAL,
      );
    },
    onRegisterError(error) {
      console.error("SW registration error:", error);
    },
  });

  const onUpdate = useCallback(() => {
    updateServiceWorker(true);
  }, [updateServiceWorker]);

  return {
    showUpdatePrompt: needRefresh,
    onUpdate,
  };
};
